module.exports = __webpack_public_path__ + "img/CyberHeroesSeriesSocialMediaFever.826b534e.jpg";